import React from 'react';
import { Button, styled } from '@mui/material';
import { UnitsFormatterProps } from './GridFormatter.props';

const primaryGreen = '#4caf50'; // Define the primary green color

interface StyleProps {
  foreignCurrency?: boolean;
}

const StyledButton = styled(Button)<StyleProps>(({ theme, foreignCurrency }) => ({
  padding: '0 14px 0 8px',
  minWidth: 'auto',
  fontSize: '12px',
  borderRadius: '0',
  borderBottomRightRadius: '10px',
  lineHeight: 'inherit',
  backgroundColor: '#fff',
  fontWeight: 800,
  maxHeight: '19px',
  color: '#b7b7b7',
  border: '1px solid #b7b7b7',
  borderLeft: 'none',
  paddingLeft: '16px !important',
  left: '-8px',
  '&:hover': {
    backgroundColor: foreignCurrency ? primaryGreen : '#fff',
  },
}));

const UnitsFormatter = ({ currency, onUnitsChanged, isLoading }: UnitsFormatterProps) => {
  const { units = '', symbol } = currency;
  const foreignCurrency = currency?.code !== 'USD'; // Determine if it's foreign currency

  return (
    <StyledButton onClick={onUnitsChanged} disabled={isLoading} foreignCurrency={foreignCurrency}>
      {`${symbol} ${units}`}
    </StyledButton>
  );
};

export default UnitsFormatter;
